"use client";

import { CalendarSync, Key, Leaf, PackageCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Benefits() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const quote = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const benefits = [{
    icon: Leaf,
    title: "Trwałość na lata",
    description: "Nasze bezspoinowe powłoki natryskowe tworzą jednolitą barierę, która skutecznie chroni dach przed wodą i promieniowaniem UV przez dekady."
  }, {
    icon: PackageCheck,
    title: "Bez zrywania papy",
    description: "Oszczędź czas i pieniądze. Technologia natryskowa pozwala na aplikację bezpośrednio na stare pokrycie, eliminując koszty utylizacji odpadów."
  }, {
    icon: CalendarSync,
    title: "Szybka aplikacja",
    description: "Dzięki nowoczesnym agregatom, proces hydroizolacji przebiega błyskawicznie, minimalizując zakłócenia w codziennym funkcjonowaniu obiektu."
  }, {
    icon: Key,
    title: "Pełna szczelność",
    description: "Eliminujemy wszelkie przecieki, tworząc elastyczną membranę, która pracuje razem z konstrukcją dachu, nie pękając przy zmianach temperatur."
  }];
  return <section data-section-id="447" id="dlaczego-hydroroof" className="bg-background text-foreground py-24 px-6 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        {}
        <div ref={header.ref} className={`mx-auto max-w-2xl text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="inline-block text-xs tracking-[0.25em] uppercase font-default font-medium" style={{
          color: "var(--primary)"
        }}>
            § HR-01 / TECH
          </span>
          <h2 className="font-default text-4xl sm:text-5xl leading-[1.05] mt-6 text-foreground font-bold">
            Dlaczego HydroRoof?
          </h2>
          <p className="mt-5 text-muted-foreground text-base sm:text-lg max-w-xl mx-auto font-default">
            Profesjonalna hydroizolacja dachów metodą natryskową – inżynieryjna precyzja w służbie Twojego bezpieczeństwa.
          </p>
        </div>

        {}
        <div ref={grid.ref} className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} className={`group relative rounded-lg bg-card border border-border p-8 transition-all duration-500 ease-out hover:-translate-y-1 hover:border-primary/40 hover:shadow-lg ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: grid.isVisible ? `${i * 100}ms` : "0ms"
          }}>
                {}
                <div className="flex items-center justify-start">
                  <div className="flex items-center justify-center w-14 h-14 rounded-lg transition-colors duration-300" style={{
                backgroundColor: "var(--accent)"
              }}>
                    <Icon className="w-7 h-7 transition-colors duration-300 group-hover:text-primary" strokeWidth={1.5} style={{
                  color: "var(--primary)"
                }} />
                  </div>
                </div>

                {}
                <h3 className="mt-8 font-default text-xl sm:text-2xl leading-snug text-foreground font-semibold">
                  {benefit.title}
                </h3>

                {}
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground font-default">
                  {benefit.description}
                </p>

                {}
                <div className="mt-8 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-lg" style={{
                backgroundColor: "var(--chart-3)"
              }} />
                  <span className="h-px w-8" style={{
                backgroundColor: "var(--chart-3)",
                opacity: 0.5
              }} />
                </div>
              </div>;
        })}
        </div>

        {}
        <div ref={quote.ref} className={`mt-20 border-t border-b border-border py-10 sm:py-12 transition-all duration-700 ease-out ${quote.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex flex-col items-center text-center gap-4 max-w-3xl mx-auto">
            <p className="font-default italic text-2xl sm:text-3xl lg:text-4xl leading-snug text-foreground">
              &ldquo;HydroRoof to gwarancja szczelności, której szukaliśmy dla naszego obiektu przemysłowego.&rdquo;
            </p>
            <span className="text-xs tracking-[0.25em] uppercase font-default font-medium mt-2" style={{
            color: "var(--primary)"
          }}>
              — Zarządca Nieruchomości, Śląsk
            </span>
          </div>
        </div>
      </div>
    </section>;
}